"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "ys-table"
  }, [_vm.$slots.toolbar || _vm.showReload || _vm.cacheId ? _c("div", {
    staticClass: "header"
  }, [_c("div", {
    staticClass: "toolbar"
  }, [_vm._t("toolbar")], 2), _vm.showReload ? _c("a-icon", {
    staticClass: "reload-icon",
    attrs: {
      type: "reload"
    },
    on: {
      click: function ($event) {
        return _vm.reload(_vm.pageConfig.pageNo);
      }
    }
  }) : _vm._e(), _vm.cacheId ? _c("table-sort", {
    ref: "tableSort",
    attrs: {
      columns: _vm.showColumns,
      "cache-id": _vm.cacheId
    },
    on: {
      "update:columns": function ($event) {
        _vm.showColumns = $event;
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _c("a-table", _vm._g(_vm._b({
    attrs: {
      bordered: "",
      size: "small",
      loading: _vm.ajaxLoading || _vm.loading,
      columns: _vm.renderColumns,
      "data-source": _vm.tableDataSource,
      scroll: _vm.tableScroll,
      pagination: _vm.visualPaginationProps,
      components: _vm.components,
      "row-selection": _vm.rowSelection
    },
    scopedSlots: _vm._u([_vm._l(_vm.$slots, function (index, name) {
      return {
        key: name,
        fn: function () {
          return [_vm._t(name)];
        },
        proxy: true
      };
    }), _vm._l(_vm.customRenderColumns, function (column) {
      return {
        key: column.scopedSlots.customRender,
        fn: function (text, record, index) {
          return [_vm._t(column.scopedSlots.customRender, null, null, {
            column,
            text,
            record,
            index
          })];
        }
      };
    })], null, true)
  }, "a-table", _vm.tableProps, false), _vm.tableEvents)), !_vm.visualPagination && _vm.pagination ? _c("div", {
    staticClass: "pagination"
  }, [_c("a-pagination", _vm._g(_vm._b({
    attrs: {
      size: "small",
      "show-size-changer": "",
      "show-quick-jumper": "",
      "show-total": total => `共 ${total} 条`,
      current: _vm.pageConfig.pageNo,
      "page-size": _vm.pageConfig.pageSize,
      total: _vm.pageConfig.total
    },
    on: {
      change: _vm.handlePageChange,
      showSizeChange: _vm.handlePageSizeChange
    }
  }, "a-pagination", _vm.paginationProps, false), _vm.paginationEvents))], 1) : _vm._e()], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;